import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
	initializeConversation,
	resetConversation,
} from '../redux/actions/chatbot'
import { ExpandIcon } from '../components/icons/ExpandIcon'
import { ContractIcon } from '../components/icons/ContractIcon'
import '../styles/chatbot.scss'
import { useIntl } from 'react-intl'
import { ChatMessages } from '../components/chatbot/ChatMessages'
import { ChatbotState } from '../redux/states/chatbot'
import { AppState, layoutActions } from '@Techedge/digitalportal-shared'
import { ChatDialog } from '../components/chatbot/ChatDialog'

interface RootState {
	chatbot: ChatbotState
}

const ChatbotContainer: React.FC = () => {
	const isChatbotOpen = useSelector(
		(state: AppState) => state.layoutReducer.isChatbotOpen
	)
	const [isFullscreen, setIsFullscreen] = useState(false)
	const dispatch = useDispatch()
	const store = useStore<RootState>()
	const intl = useIntl()
	const accessToken = useSelector(
		(state: AppState) => state.userReducer.accessToken
	)
	const language = useSelector(
		(state: AppState) => state.userReducer.user.language
	)

	useEffect(() => {
		if (accessToken)
			initializeConversation()(dispatch, store.getState, language)
	}, [accessToken])

	const handleNewChat = async () => {
		await resetConversation()(dispatch, store.getState, language)
	}

	const headerTemplate = (
		<div className="chatbot-header">
			<div className="chatbot-title">
				{intl.formatMessage({
					id: 'chatbot.title',
					defaultMessage: 'Ask AI',
				})}
			</div>
			<div className="chatbot-actions">
				<button
					className="p-button p-button-text p-button-plain"
					onClick={handleNewChat}
					style={{
						background: 'transparent',
						border: 'none',
						padding: '0.5rem',
						cursor: 'pointer',
						color: 'var(--text-color-secondary)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					<i className="pi pi-plus" />
				</button>
				<button
					className="p-button p-button-text p-button-plain"
					onClick={() => setIsFullscreen(!isFullscreen)}
					style={{
						background: 'transparent',
						border: 'none',
						padding: '0.5rem',
						cursor: 'pointer',
						color: 'var(--text-color-secondary)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					{isFullscreen ? (
						<ContractIcon size={16} />
					) : (
						<ExpandIcon size={16} />
					)}
				</button>
				<button
					className="p-button p-button-text p-button-plain"
					onClick={() =>
						dispatch(layoutActions.setIsChatbotOpen(false))
					}
					style={{
						background: 'transparent',
						border: 'none',
						padding: '0.5rem',
						cursor: 'pointer',
						color: 'var(--text-color-secondary)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
					<i className="pi pi-times" />
				</button>
			</div>
		</div>
	)

	return (
		<div style={{ position: 'relative', zIndex: 99999 }}>
			<ChatDialog
				visible={isChatbotOpen}
				onHide={() => dispatch(layoutActions.setIsChatbotOpen(false))}
				fullScreen={isFullscreen}
				header={headerTemplate}
			/>
		</div>
	)
}

export default ChatbotContainer
